



































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { ListJkySyncLogByOrderCode, QueryHouseByCode, QueryOrderGoodsDescList, QueryOrderInfoByCode, QueryOrderWealthDetail } from '@/api'
import { TableHander } from '@/components/table'
import { VTable } from '@/components/table'
import { PriceFormat, RefundStatusFormat } from '@/utils/tyepconvert'
import { DateFormat, DateFormat2 } from '@/utils/date/DateUtil'
import HouseDescDialog from '@/views/house/HouseDescDialog.vue'
import ExpressDialog from './componetns/ExpressDialog.vue'
import UpdateDeliveryTypeDialog from './componetns/UpdateDeliveryTypeDialog.vue'
import UpdateDeliveryInfoDialog from './componetns/UpdateDeliveryInfoDialog.vue'

@Component({
  components: {
    VTable,
    HouseDescDialog,
    ExpressDialog,
    UpdateDeliveryTypeDialog,
    UpdateDeliveryInfoDialog
  },
})
export default class OrderDescDialog extends Vue {
  private show = false
  private data: any = {
    userInfo: {},
    shop: {}
  }
  private house: any = {}
  private tableData = []
  /** 退款/退货单列表（接口 orderRefundList） */
  private refundTableData: any[] = []
  private jkyLogList: any[] = []
  private jkyLogLoading = false
  private wealthDetail: any = null
  private wealthLoading = false
  private wealthTab = 'user'
  private shopName = ""
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    // { title: '供应商', param: 'supplierCode' },
    { title: '商品图片', param: 'goodsMainImg' , width: 80 , type:'image' },
    { title: '商品编号', param: 'goodsCode' },
    { title: '商品名称', param: 'goodsName' },
    { title: '供应链名称', param: 'supplyChainName' },
    { title: '工厂名称', param: 'factoryName' },
    { title: 'SKU规格', param: 'skuSpecDesc' },
    { title: '商品数量', param: 'count', width: 80 },
    { title: '已退数量', param: 'refundCount', width: 80, formatter: (v: any) => (v != null && v > 0) ? v : '-' },
    { title: '商品PV(单价/分)', param: 'pv', width: 120, formatter: this.pvUnitFenFormat },
    { title: '商品单价', param: 'price', width: 120, formatter: PriceFormat },
    { title: '总销售金额(下单)', param: 'orderAmount', width: 130, formatter: PriceFormat },
    { title: '总销售金额(剩余)', param: '_salesRemainFen', width: 130, formatter: PriceFormat },
    { title: '总PV(下单/分)', param: '_pvOriginalFen', width: 130, formatter: this.pvTotalFenFormat },
    { title: '总PV(剩余/分)', param: '_pvRemainFen', width: 130, formatter: this.pvTotalFenFormat },
    // { title: '物流单号', param: 'expressCode' },
    // { title: '活动时销售金额', param: 'activitySalesIntegral', formatter: PriceFormat },
  ]

  private refundTableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '退款单号', param: 'orderRefundCode', width: 180, overflow: true },
    { title: '方式', param: 'refundType', width: 88, formatter: this.refundTypeCellFormat },
    { title: '状态', param: 'refundStatus', width: 120, formatter: RefundStatusFormat },
    { title: '金额', param: 'refundAmount', width: 90, formatter: PriceFormat },
    { title: '退款原因', param: 'refundReason', width: 160, overflow: true },
    { title: '退货物流', param: 'expressCode', width: 140, overflow: true, formatter: this.refundExpressFormat },
    { title: '失败原因', param: 'errorMsg', width: 140, overflow: true },
    { title: '商品/数量', param: 'goodsLines', width: 260, overflow: true, formatter: this.refundGoodsFormat },
    { title: '申请时间', param: 'createTime', width: 150, formatter: DateFormat, overflow: true },
    { title: '退款成功时间', param: 'successRefundTime', width: 150, formatter: DateFormat, overflow: true },
  ]

  @Emit('close')
  private close() {
    this.show = false
    this.data = {
      userInfo: {},
      shop: {}
    }
    this.house = {}
    this.tableData = []
    this.refundTableData = []
    this.jkyLogList = []
    this.wealthDetail = null
    this.wealthTab = 'user'
  }
  public open(param: any) {
    this.show = true
    this.data.orderCode = param.orderCode
    // this.shopName = param.shopName
    this.loadData()
    this.loadDataList()
    // this.loadHouse(param.houseCode)
    // this.loadUser(param.userNo)
  }

  public onload(){
    this.loadData()
  }

  /** 单价 PV：分 + 折算元（与 PriceFormat 一致） */
  private pvUnitFenFormat(_v: any, row: any) {
    const fen = Number(row.pv) || 0
    return this.pvTotalFenFormat(fen, row)
  }

  /** 行合计 PV（分）：展示「分」与折算元，便于与退款前后对比 */
  private pvTotalFenFormat(fenVal: any, _row?: any) {
    const fen = Math.round(Number(fenVal) || 0)
    const yuan = PriceFormat(fen)
    return `${fen}分（${yuan}）`
  }

  /** 明细行：按已退数量计算剩余销售额、退款前后 PV 合计（分） */
  private enrichOrderDescRow(row: any) {
    const c = Math.max(0, Number(row.count) || 0)
    const rc = Math.max(0, Number(row.refundCount) || 0)
    const refunded = Math.min(rc, c)
    const remain = Math.max(0, c - refunded)
    const pvUnit = Math.round(Number(row.pv) || 0)
    const oa = Math.round(Number(row.orderAmount) || 0)
    const salesRemainFen = c > 0 ? Math.round((oa * remain) / c) : 0
    return {
      ...row,
      _remainCount: remain,
      _salesRemainFen: salesRemainFen,
      _pvOriginalFen: pvUnit * c,
      _pvRemainFen: pvUnit * remain,
    }
  }

  /** 分 → 元（与 PriceFormat 一致） */
  private snapMoneyYuan(cents: any) {
    if (cents == null || cents === '') {
      return '-'
    }
    return PriceFormat(Number(cents))
  }

  /** 贡献值为整数点值，非金额分 */
  private snapPlainNumber(v: any) {
    if (v == null || v === '') {
      return '-'
    }
    return String(v)
  }

  private snapEnergy(v: any) {
    if (v == null || v === '') {
      return '-'
    }
    const n = Number(v)
    if (Number.isNaN(n)) {
      return String(v)
    }
    return n.toFixed(4)
  }

  private refundTypeCellFormat(v: any) {
    // 与 C 端/后端 zy_order_refund.refund_type 一致：1=仅退款 2=退货退款
    return Number(v) === 2 ? '退货退款' : '仅退款'
  }

  private refundExpressFormat(_v: any, row: any) {
    const c = row.expressCompanyCode ? String(row.expressCompanyCode) + ' ' : ''
    const e = row.expressCode ? String(row.expressCode) : ''
    const t = (c + e).trim()
    return t || '-'
  }

  private refundGoodsFormat(_v: any, row: any) {
    const lines = row.goodsLines
    if (!lines || !lines.length) {
      return '-'
    }
    return lines.map((g: any) => {
      const spec = g.skuSpecDesc ? '(' + g.skuSpecDesc + ')' : ''
      return (g.goodsName || '-') + spec + '×' + (g.count != null ? g.count : 0)
    }).join('、')
  }

  // 打开物流详情弹窗
  private openExpress(){
    const t = this.$refs.ExpressDialog as ExpressDialog
     // TODO 传入物流编号
    t.open(this.data.orderCode)
  }

  private handleUpdateDeliveryType(){
     const t = this.$refs.UpdateDeliveryTypeDialog as UpdateDeliveryTypeDialog
    t.open(this.data)
  }
  private handleUpdateDeliveryInfo(){
     const t = this.$refs.UpdateDeliveryInfoDialog as UpdateDeliveryInfoDialog
    t.open(this.data)
  }

  private getGoodsBanner(value: string){
    if(value){
      const vs = value.split(",")
      return vs[0]
    }
    return ""
  }


  private async loadHouse(houseCode: string) {
    const result = await QueryHouseByCode({ houseCode })
    this.house = result
  }

  private async loadData() {
    const result = await QueryOrderInfoByCode({ orderCode: this.data.orderCode })
    this.data = result
    this.refundTableData = Array.isArray(result.orderRefundList) ? result.orderRefundList : []
    this.loadJkyLogs()
    this.loadWealthDetail()
  }

  private get couponUsedLabel() {
    const amt = this.data && this.data.couponAmount != null ? Number(this.data.couponAmount) : 0
    return amt > 0 ? '是' : '否'
  }

  private get userWealthRows() {
    const d = this.wealthDetail
    return d && Array.isArray(d.userWealthList) ? d.userWealthList : []
  }

  private get shopWealthRows() {
    const d = this.wealthDetail
    return d && Array.isArray(d.shopWealthList) ? d.shopWealthList : []
  }

  private get platformWealthRows() {
    const d = this.wealthDetail
    return d && Array.isArray(d.platformWealthList) ? d.platformWealthList : []
  }

  private async loadWealthDetail() {
    const oc = this.data.orderCode
    if (!oc) {
      return
    }
    this.wealthLoading = true
    try {
      const res = await QueryOrderWealthDetail({ orderCode: oc })
      this.wealthDetail = res || null
    } finally {
      this.wealthLoading = false
    }
  }

  private async loadJkyLogs() {
    const oc = this.data.orderCode
    if (!oc) {
      return
    }
    this.jkyLogLoading = true
    try {
      const list = await ListJkySyncLogByOrderCode({ orderCode: oc })
      this.jkyLogList = Array.isArray(list) ? list : []
    } finally {
      this.jkyLogLoading = false
    }
  }

  private jkyTimeFormat(_row: any, _col: any, cell: any) {
    return cell ? DateFormat(cell) : '-'
  }

  private jkyDirectionFormat(_row: any, _col: any, cell: any) {
    const d = Number(cell)
    if (d === 1) {
      return '→吉客云'
    }
    if (d === 2) {
      return '吉客云→'
    }
    if (d === 0) {
      return '本地变更'
    }
    return '-'
  }

  private jkyBizTypeFormat(row: any) {
    const m: Record<string, string> = {
      PUSH_ORDER: '推送订单',
      PUSH_REFUND_NOTIFY: '推送售后/退款通知',
      NOTIFY_ORDER: '订单变更通知',
      CALLBACK_SHIP: '回调：发货',
      CALLBACK_REFUND_STATUS: '回调：查退款状态',
      CALLBACK_AFTERSALE: '回调：售后审核',
      CALLBACK_GET_REFUND: '回调：拉取退款单',
      CALLBACK_GET_ORDER: '回调：订单下载(GetOrder)',
      ORDER_STATUS_CHANGE: '订单状态变更',
      REFUND_STATUS_CHANGE: '退款状态变更',
    }
    return m[row.bizType] || row.bizType || '-'
  }

  private wealthDecimalFmt(row: any) {
    return this.decimalCell(row.qty)
  }

  private wealthShouldFmt(row: any) {
    return this.decimalCell(row.shouldQty)
  }

  private wealthVQtyFmt(row: any) {
    return this.decimalCell(row.vQty)
  }

  private wealthAmountFmt(row: any) {
    return this.decimalCell(row.amount)
  }

  private wealthZhiFmt(row: any) {
    const cell = row.iszhi
    if (cell === 1) {
      return '是'
    }
    if (cell === 0) {
      return '否'
    }
    return '-'
  }

  private shopQtyYuanFmt(row: any) {
    const q = row.qty
    if (q == null || q === '') {
      return '-'
    }
    return PriceFormat(Number(q))
  }

  private platDecimalFmt(row: any) {
    return this.decimalCell(row.platformPv)
  }

  private platOrderPvFmt(row: any) {
    return this.decimalCell(row.orderPv)
  }

  private platMemberFmt(row: any) {
    return this.decimalCell(row.memberTotalPv)
  }

  private platShopFmt(row: any) {
    return this.decimalCell(row.shopInvitePv)
  }

  private platAmountFmt(row: any) {
    return this.decimalCell(row.amount)
  }

  private platPv2Fmt(row: any) {
    return this.decimalCell(row.platformPv2)
  }

  private decimalCell(v: any) {
    if (v == null || v === '') {
      return '-'
    }
    const n = Number(v)
    if (Number.isNaN(n)) {
      return String(v)
    }
    return String(n)
  }

  private formatJkyDetail(raw: string) {
    if (!raw) {
      return '-'
    }
    try {
      return JSON.stringify(JSON.parse(raw), null, 2)
    } catch {
      return raw
    }
  }

  /** 吉客云日志 detailJson 常见键顺序与中文说明（出站/入站合并） */
  private jkyDetailDebugEntries(row: any): Array<{ key: string; label: string; value: string }> {
    const raw = row && row.detailJson
    if (!raw || typeof raw !== 'string') {
      return []
    }
    const order = [
      'requestUrl',
      'postParamsMasked',
      'requestData',
      'responseRaw',
      'callbackRequestFull',
      'responseToJky',
      'processResultOrResponse',
      'note',
    ]
    const labels: Record<string, string> = {
      requestUrl: '请求地址',
      postParamsMasked: '表单参数(脱敏)',
      requestData: '业务 data / 请求体',
      responseRaw: '吉客云原始响应',
      callbackRequestFull: '回调 HTTP 原文',
      responseToJky: '返回吉客云的 JSON',
      processResultOrResponse: '处理结果/响应(兼容)',
      note: '备注说明',
    }
    const formatVal = (v: any) => {
      if (v === null || v === undefined) {
        return ''
      }
      if (typeof v === 'object') {
        try {
          return JSON.stringify(v, null, 2)
        } catch {
          return String(v)
        }
      }
      return String(v)
    }
    try {
      const obj = JSON.parse(raw)
      if (!obj || typeof obj !== 'object') {
        return []
      }
      const seen = new Set<string>()
      const out: Array<{ key: string; label: string; value: string }> = []
      for (const k of order) {
        if (!Object.prototype.hasOwnProperty.call(obj, k)) {
          continue
        }
        const v = obj[k]
        if (v === '' || v == null) {
          continue
        }
        const text = formatVal(v)
        if (text === '') {
          continue
        }
        out.push({ key: k, label: labels[k] || k, value: text })
        seen.add(k)
      }
      for (const k of Object.keys(obj)) {
        if (seen.has(k)) {
          continue
        }
        const v = obj[k]
        if (v === '' || v == null) {
          continue
        }
        const text = formatVal(v)
        if (text === '') {
          continue
        }
        out.push({ key: k, label: labels[k] || k, value: text })
      }
      return out
    } catch {
      return []
    }
  }

  public async loadDataList() {
    const result = await QueryOrderGoodsDescList({ orderCode: this.data.orderCode })
    const list = Array.isArray(result.list) ? result.list : []
    this.tableData = list.map((row: any) => this.enrichOrderDescRow(row))
  }

  public async save() {
    console.log('s')
  }

  private openHouse() {
    const hd = this.$refs.HouseDescDialog as HouseDescDialog
    hd.open(this.house.houseCode)
  }
}
